import React from 'react';
import { Button, Modal, ModalProps, Typography } from 'antd';
import { useIntl } from 'react-intl';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;

interface TopUpWarningModalProps extends Omit<ModalProps, 'children' | 'onCancel'> {
  onAgree: () => void;
  loading?: boolean;
}

const TopUpWarningModal: React.FC<TopUpWarningModalProps> = ({
  onAgree,
  loading = false,
  ...props
}) => {
  const { formatMessage: t } = useIntl();

  return (
    <Modal
      {...props}
      centered
      open={props.open}
      onCancel={undefined}
      footer={null}
      closable={false}
      maskClosable={false}
      width={400}
      style={{ borderRadius: 16 }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: 24,
          textAlign: 'center'
        }}
      >
        <ExclamationCircleOutlined
          style={{ 
            color: '#FF2E2E', 
            fontSize: 48, 
            marginBottom: 16 
          }}
        />
        
        <Title 
          level={4} 
          style={{ 
            marginBottom: 16, 
            textAlign: 'center',
            fontWeight: 700,
            color: '#000'
          }}
        >
          {t({ id: 'sepa.warning.title' })}
        </Title>
        
        <Text 
          style={{ 
            color: '#666', 
            fontSize: 14, 
            marginBottom: 24, 
            textAlign: 'center',
            lineHeight: '20px'
          }}
        >
          {t({ id: 'sepa.warning.desc' })}
        </Text>
        
        <Button
          block
          type="primary"
          loading={loading}
          style={{ 
            background: '#191919', 
            color: '#fff', 
            fontWeight: 500,
            height: 44,
            borderRadius: 8
          }}
          onClick={onAgree}
        >
          {t({ id: 'buttons.submit', defaultMessage: 'Submit' })}
        </Button>
      </div>
    </Modal>
  );
};

export default TopUpWarningModal;
